import { atom } from 'recoil';

export const loginUser = atom({
  key: 'loginUser',
  default: null,
});
